import { useContext } from 'react'

import { ThemeContext } from '../../contexts'
import { useStyles } from '../../hooks/useStyles/useStyles'

export const useThemedStyles = (styles) => {
  const themeContext = useContext(ThemeContext)

  return useStyles(styles, { theme: themeContext.theme })
}
